import type { TradeType } from '@/types';

// Display labels for trade-type codes, shown in the trade-type <select> of the
// entry form. Shared by the create (useCreateTradeForm) and amend
// (useAmendTradeForm) hooks — single source so the two never drift (LR-495).
export const TRADE_TYPE_LABELS: Record<TradeType, string> = {
  lend: 'Stock Lending',
  borrow: 'Stock Borrowing',
  repo: 'Repo',
  reverse_repo: 'Reverse Repo',
};
